import faker from 'faker';
import moment from 'moment';

export default Array(10)
  .fill(0)
  .map((_, index) => {
    return {
      id: index,
      contrato: faker.random.number({ min: 1000, max: 5000 }),
      fornecedor: faker.name.findName(),
      numeroControle: faker.finance.account(),
      assunto: faker.lorem.sentence(),
      dataEnvio: moment(faker.date.recent(10)).format('DD/MM/YYYY'),
      prazoResposta: faker.random.number({ min: 0, max: 9 }),
    };
  });
